import {Order, OrderField} from "../../../../app/api/model/order";
import React from "react";
import {getOrderShippingRecipientValidationSchema} from "../validation";
import {UseModal} from "../../../../hooks/useModal";
import {InputFieldType} from "../../../../components/input/factory/types";
import UpdateDialog from "../../../../components/Dialog/UpdateDialog";
import {OrderUpdateRecipientRequest, useOrderUpdateRecipientMutation} from "../../../../app/api/api";

export interface OrderDetailsShippingRecipientFormParams {
    order?: Order;
    onSuccess?: () => void;
    modal: UseModal;
}

export default function OrderDetailsShippingRecipientForm({
    order,
    modal,
    onSuccess,
}: OrderDetailsShippingRecipientFormParams) {
    const [updatedateRecipient] = useOrderUpdateRecipientMutation();
    const initialValues = {
        id: order?.id,
        shippingRecipient: order?.shippingRecipient,
        adminUser: order?.adminUser,
        comment: order?.comment,
    };
    return (
        <UpdateDialog
            titleKey={"action_updateShippingRecipient"}
            modal={modal}
            validationSchema={getOrderShippingRecipientValidationSchema}
            inputFields={[
                {
                    translationKey: "user_firstName",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "contact.firstName",
                    required: true,
                },
                {
                    translationKey: "user_lastName",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "contact.lastName",
                    required: true,
                },
                {
                    translationKey: "generic_email",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "contact.email",
                    required: true,
                },
                {
                    translationKey: "generic_phone",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "contact.phone",
                },
                {
                    translationKey: "generic_company",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "companyName",
                    required: true,
                },
                {
                    translationKey: "generic_street",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "address.street",
                    required: true,
                },
                {
                    translationKey: "generic_streetNumber",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "address.houseNumber",
                },
                {
                    translationKey: "generic_addressAddition",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "address.addressAddition",
                },
                {
                    translationKey: "generic_city",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "address.city",
                    required: true,
                },
                {
                    translationKey: "generic_addressPostalCode",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "address.postalCode",
                    required: true,
                },
                {
                    translationKey: "generic_country",
                    fieldName: OrderField.SHIPPING_RECIPIENT,
                    subFieldName: "address.country",
                    type: InputFieldType.COUNTRY,
                    required: true,
                },
            ]}
            onSuccess={onSuccess}
            entity={order}
            spacing={5}
            initialValues={initialValues}
            onSubmit={async (payload: Partial<Order>) => {
                const requestData: OrderUpdateRecipientRequest = {
                    id: payload.id!,
                    shippingRecipient: payload.shippingRecipient!,
                };
                await updatedateRecipient(requestData).unwrap();
            }}
        />
    );
}
